var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_0_160)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8 3.33398V7.33398M8 9.33398V10.334M8 12.334V12.6673",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F04438"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.6667 6.00065L8 3.33398",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F04438"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.33325 6.00065L7.99992 3.33398",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F04438"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendDown);
export default __webpack_public_path__ + "static/media/trend-down.3305262affa261024bcfeeb7c9cf84a9.svg";
export { ForwardRef as ReactComponent };